import React, { useState } from 'react';
import { DropdownMenu } from '@spark';
import LanguageSelector from './LanguageSelector';
import HighlightedCode from './HighlightedCode';
import CodeSnippetActions from '@/shared/components/CodeSnippetActions';
import {
    LOGGING_LANGUAGES,
    LOGGING_TASK_TYPES,
    LOGGING_FILE_EXTENSIONS,
    getLoggingScript,
} from './loggingExamples';

const HLJS_LANGUAGE = { python: 'python', typescript: 'typescript', go: 'go' };

const LoggingCodeBlock = () => {
    const [selectedLanguage, setSelectedLanguage] = useState('python');
    const [selectedTaskType, setSelectedTaskType] = useState('classification');
    const [taskTypeOpen, setTaskTypeOpen] = useState(false);

    const baseUrl = `${window.location.origin}/`;

    const code = getLoggingScript({
        language: selectedLanguage,
        taskType: selectedTaskType,
        baseUrl,
    });

    const extension = LOGGING_FILE_EXTENSIONS[selectedLanguage] || 'txt';
    const filename = `specific_ai_log_${selectedTaskType}.${extension}`;

    const taskTypeItems = LOGGING_TASK_TYPES.map((t) => ({
        label: t.label,
    }));

    const handleTaskTypeSelect = (item) => {
        const match = LOGGING_TASK_TYPES.find((t) => t.label === item.label);
        if (match) setSelectedTaskType(match.value);
        setTaskTypeOpen(false);
    };

    const selectedTaskLabel = LOGGING_TASK_TYPES.find((t) => t.value === selectedTaskType)?.label || 'Classification';

    return (
        <div className="docs-code-block">
            <div className="docs-code-toolbar">
                <DropdownMenu
                    size="small"
                    showLabel={false}
                    items={taskTypeItems}
                    value={selectedTaskLabel}
                    text={selectedTaskLabel}
                    open={taskTypeOpen}
                    onOpenChange={setTaskTypeOpen}
                    onSelect={handleTaskTypeSelect}
                    className="docs-task-type-selector"
                    panelClassName="docs-code-selector-panel"
                />
                <LanguageSelector
                    selectedLanguage={selectedLanguage}
                    onLanguageChange={setSelectedLanguage}
                    languages={LOGGING_LANGUAGES}
                />
                <CodeSnippetActions
                    code={code}
                    filename={filename}
                    variant="secondary"
                />
            </div>
            <HighlightedCode code={code} language={HLJS_LANGUAGE[selectedLanguage]} />
        </div>
    );
};

export default LoggingCodeBlock;
